import { useState, useEffect, useRef } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
// import { useHistory } from 'react-router-dom';

// @Utility
import currencyFormat from "./../../../../../../@utility/numbers/currencyFormat";

// auth
import { isUserLoggedIn } from "./../../../../../../@core/auth/utils";

// Redux
// import { setDataDialog } from "./../../../../../../@core/redux/actions/app/dialog";
import { setDataAlert } from "./../../../../../../@core/redux/actions/app/alert";
import { setHomeMenuType } from "./../../../../../../@core/redux/actions/home/index";

// Services
import { likeGame } from "../../../../../../@core/services/gameService";

// Icon
// import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

// Component
import OpenGame from "./../../../components/OpenGame";
import ProgressiveImage from "./../../../components/ProgressiveImage";

// CSS
import styles from "./../../../assets/css/Style.module.css";
// import buttonStyles from "./../../../assets/css/Button.module.css";
import bagdeStyles from "./../../../assets/css/Bagde.module.css";

export default function ListGame({ pageName, pageType }) {
    // const history = useHistory();
    const dataSetting = useSelector(state => state.reduxAppMenu.menu_items);
    const itemsGameHotList = useSelector(state => state.reduxGame.itemsGameHotList);
    const itemsGameJackpotList = useSelector(state => state.reduxGame.itemsGameJackpotList);
    const itemsCasinoList = useSelector(state => state.reduxGame.itemsCampList);
    const homeData = useSelector(state => state.reduxHome.result);
    const [gameList, setGameList] = useState(null);
    const dispatch = useDispatch();
    const [hearthStatus, setHearthStatus] = useState(null);
    const [checkPromotion, setCheckPromotion] = useState(null);
    const slideRef = useRef();
    const imageRef = useRef();
    const reduxAppScrollPosition = useSelector(state => state.reduxAppScrollPosition.top);
    const reduxAppCMS = useSelector(state => state.reduxAppCMS.cms);
    const gameRef = useRef();
    // const settings = {
    //     infinite: true,
    //     // fade: false,
    //     dots: false,
    //     slidesToShow: isLargeScreen ? 5 : 3,
    //     slidesToScroll: isLargeScreen ? 5 : 3,
    //     autoplay: false,
    //     speed: 600,
    //     autoplaySpeed: 6000,
    //     arrows: false,
    //     pauseOnHover: true
    // };

    const useStyles = makeStyles((theme) => ({
        cardGameBody: {
            // background: reduxAppCMS !== null ? reduxAppCMS["bg-card"] : "white",
            borderRadius: "15px",
            // padding: "9px 18px",
            // padding: "30px",
            [theme.breakpoints.down('xs')]: {
                borderRadius: "0px",
                padding: "15px 5px"
            }
            // padding: "18px"
        },
        gameSize: {
            width: "100%",
            height: "100%",
            borderRadius: "16px",
            cursor: "pointer",
            [theme.breakpoints.down('xs')]: {
                borderRadius: "10px"
            }
            // [theme.breakpoints.down('xs')]: {
            //     height: "160px"
            // }
        },
        // casinoSize: {
        //     width: "240px",
        //     height: "100%",
        //     borderRadius: "16px",
        //     cursor: "pointer",
        //     [theme.breakpoints.down('xs')]: {
        //         width: "100%",
        //         height: "100%"
        //     }
        // },
        cardGameMenu: {
            // borderBottom: "2px solid #F0F1F9",
            padding: "0px 12px"
        },
        cardGameList: {
            padding: "20px 0px",
            [theme.breakpoints.down('xs')]: {
                padding: "20px 0px 0px 0px"
            }
        },
        menuList: {
            border: "2px solid #F0F1F9",
            borderRadius: "18px",
            fontSize: "18px",
            padding: "4px 24px",
            cursor: "pointer",
            position: "relative",
            color: "white",
            '&:hover': {
                background: "linear-gradient(90deg, #360092 0%, #A60E97 100%)"
            }
        },
        heartContentPosition: {
            position: "absolute",
            top: "-6px",
            right: "-6px"
        },
        heartContent: {
            width: "44px",
            height: "auto",
            cursor: "pointer",
            // [theme.breakpoints.down('md')]: {
            //     width: "36px",
            // },
            [theme.breakpoints.down('xs')]: {
                width: "34px"
            }
        },
        gameSizePadding: {
            padding: "10px 4px",
            marginBottom: "10px",
            width: "190px",
            height: "100%",
            [theme.breakpoints.down('sm')]: {
                marginBottom: "0px",
            },
            [theme.breakpoints.down('xs')]: {
                padding: "6px 4px",
                width: "120px"
            }
        },
        casinoSizePadding: {
            padding: "10px 4px",
            marginBottom: "10px",
            width: "240px",
            height: "100%",
            [theme.breakpoints.down('sm')]: {
                marginBottom: "0px",
            },
            [theme.breakpoints.down('xs')]: {
                padding: "6px 4px",
                width: "170px"
            }
        },
        gameMore: {
            fontSize: "18px",
            color: reduxAppCMS !== null ? reduxAppCMS["bt-danger"] : "#FF0000",
            fontWeight: "600",
            cursor: "pointer",
            [theme.breakpoints.down('xs')]: {
                fontSize: "15px"
            }
        },
        pageTypePosition: {
            position: "absolute",
            left: "0px",
            top: "-10px"
        },
        pageTypeJackpotPositionBottom: {
            position: "absolute",
            left: "-2px",
            bottom: "2px"
        },
        pageTypeJackpotPositionTop: {
            position: "absolute",
            left: "-2px",
            top: "-2px"
        },
        pageTypeSize: {
            width: "64px",
            height: "auto"
        },
        pageTypeJackpotCount: {
            background: "linear-gradient(180deg, #00E0FF 0%, #0066FF 100%)",
            color: "white",
            borderRadius: "0px 8px 0px 8px",
            padding: "2px 12px",
            fontWeight: "600",
            boxShadow: "0 4px 8px 0 rgb(0 0 0 / 40%)"
        }
    }));

    const classes = useStyles();

    const loadGame = (item) => {
        gameRef.current.loadGame(item, "game");
    };

    const renderHearth = (item, index) => {
        return (
            item.like === false ?
                <img src="/images/icon/hearth_not_active.webp" className={classes.heartContent} onClick={() => { clickLikeGame(item, index, true) }} alt=" เว็บตรง ลิขสิทธิ์แท้ ไม่ผ่านเอเย่นต์ คาสิโน สล็อต กีฬา  ฝาก - ถอน ระบบอัตโนมัติ 24 ชม" />
                :
                <img src="/images/icon/hearth_active.webp" className={classes.heartContent} onClick={() => { clickLikeGame(item, index, false) }} alt=" เว็บตรง ลิขสิทธิ์แท้ ไม่ผ่านเอเย่นต์ คาสิโน สล็อต กีฬา  ฝาก - ถอน ระบบอัตโนมัติ 24 ชม" />
        );
    };

    const clickLikeGame = (item, index, statusActive) => {
        if (isUserLoggedIn()) {
            let myJson = {};
            let gameListBackup = gameList;

            if (item.like === false) {
                myJson = {
                    gameId: Number(item.id),
                    statusLike: true
                };
            }
            else {
                myJson = {
                    gameId: Number(item.id),
                    statusLike: false
                };
            }

            if (statusActive) {
                gameListBackup[index].like = true;
            }
            else {
                gameListBackup[index].like = false;
            }

            setGameList(gameListBackup);
            setHearthStatus(statusActive);

            likeGame(myJson).then(() => {
                setHearthStatus(null);
            });
        }
        else {
            dispatch(setDataAlert({
                type: "warning",
                title: "แจ้งเตือน",
                text: `กรุณาเข้าสู่ระบบก่อนเข้าใช้งาน "เพิ่มเกมที่ชื่นชอบ"`,
                action: true,
                redirect: "/login",
                show: true,
                buttonText: "ตกลง"
            }));
        }
    };

    const renderBagde = (item) => {
        if (item.status === 3) {
            return (
                <div className={bagdeStyles.ribbonPosition}>
                    <div className={[bagdeStyles.ribbon, bagdeStyles.ribbonDanger].join(" ")}>
                        ปิดปรับปรุง
                    </div>
                </div>
            );
        }
        else if (item.status === 2) {
            if (item.spin === 1 || item.promotion === 1) {
                if (checkPromotion === 1 && item.promotion === 1) {
                    return (
                        <div className={bagdeStyles.ribbonPosition}>
                            <div className={[bagdeStyles.ribbon, bagdeStyles.ribbonDanger].join(" ")}>
                                ติดโปรโมชั่น
                            </div>
                        </div>
                    );
                }
                else if (item.spin === 1) {
                    return (
                        <div className={bagdeStyles.ribbonPosition}>
                            <div className={[bagdeStyles.ribbon, bagdeStyles.ribbonWarning].join(" ")}>
                                ซื้อฟรีสปิน
                            </div>
                        </div>
                    );
                }
            }
            else {
                if (item.specials !== "") {
                    let specialType = item.specials.split(",");

                    if (specialType.length > 1) {
                        return (
                            <div className={bagdeStyles.ribbonPosition}>
                                <div className={[bagdeStyles.ribbon, bagdeStyles.ribbonPrimary].join(" ")}>
                                    มาใหม่
                                </div>
                            </div>
                        );
                    }
                    else {
                        let selectTypeNew = specialType.find((str) => str === "new");
                        let selectTypeHot = specialType.find((str) => str === "hot");

                        if (selectTypeNew != undefined) {
                            return (
                                <div className={bagdeStyles.ribbonPosition}>
                                    <div className={[bagdeStyles.ribbon, bagdeStyles.ribbonPrimary].join(" ")}>
                                        มาใหม่
                                    </div>
                                </div>
                            );
                        }

                        if (selectTypeHot != undefined) {
                            return (
                                <div className={bagdeStyles.ribbonPosition}>
                                    <div className={[bagdeStyles.ribbon, bagdeStyles.ribbonYellow].join(" ")}>
                                        มาแรง
                                    </div>
                                </div>
                            );
                        }
                    }
                }
            }
        }
        else {
            return null;
        }
    };

    const gotoDemo = () => {
        let menuList = dataSetting.menu_camp;
        let dataObj = {};

        if(pageType === "casino") {
            let index = menuList.findIndex(item => item.code === "casino");
            dataObj = menuList[index];
            dataObj.id = index;
        }
        else {
            let index = menuList.findIndex(item => item.code === "slot");
            dataObj = menuList[index];
            dataObj.id = index;
        }
        
        if(dataObj !== undefined && dataObj !== null) {
            dispatch(setHomeMenuType({
                id: dataObj.id,
                renderPage: dataObj.code,
                pageTitle: dataObj.title,
                game_camp_image: dataObj.game_camp_image,
                column: {
                    desktop: dataObj.column_desktop,
                    mobile: dataObj.column_mobile
                },
                typeGame: dataObj.game_camp_type
            }));

            window.scrollTo({
                top: reduxAppScrollPosition,
                left: 0,
                behavior: "smooth"
            });        
        }
    };

    useEffect(() => {
        if (pageType === "jackpot") {
            setGameList(itemsGameJackpotList);
        }
        else if (pageType === "casino") {
            if(itemsCasinoList !== null) {
                if(itemsCasinoList.length > 0) {
                    const filterCasino = itemsCasinoList.filter((item) => {
                        return item.category === 1;
                    });

                    const dataCasino = [];
                    filterCasino.forEach((item, index) => {
                        dataCasino.push({...item, image: item.image_hot, id: index})
                    });

                    if(dataCasino.length > 0) {
                        setGameList(dataCasino);
                    }
                }
            }
        }
        else {
            setGameList(itemsGameHotList);
        }

        if (isUserLoggedIn()) {
            if (homeData !== null) {
                setCheckPromotion(homeData.promotion_status);
            }
        }
    }, [hearthStatus, pageType, itemsGameJackpotList, itemsGameHotList, itemsCasinoList]);

    return (
        <>
            <OpenGame ref={gameRef}></OpenGame>
            <div className={classes.cardGameBody}>
                <div className={classes.cardGameMenu}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <div className={styles.cardOtherListHeadText}>
                                {pageName}
                            </div>
                        </Grid>
                        <Grid item>
                            <div className={classes.gameMore} onClick={gotoDemo}>
                                เพิ่มเติม
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className={classes.cardGameList}>
                    <div className={styles.menuPositionWidthScroll} ref={slideRef}>
                        <div className="flexContent">
                            {
                                gameList !== null && (
                                    gameList.map((item, index) => {
                                        return (
                                            <div key={item.id}>
                                                <div className={classes.gameSizePadding}>
                                                    <div className="relative">
                                                        {
                                                            renderBagde(item, "gameList")
                                                        }

                                                        <ProgressiveImage className={classes.gameSize} placeholder="/images/bluring/215x280.jpg" src={item.image} imageRef={imageRef} onClick={() => ((item.status === 3 || item.status === 0 || item.status === 1) || (checkPromotion === 1 && item.promotion === 1)) ? null : loadGame(item)}></ProgressiveImage>

                                                        {/* <img className={classes.gameSize} src={item.image} ref={imageRef} alt=" เว็บตรง ลิขสิทธิ์แท้ ไม่ผ่านเอเย่นต์ คาสิโน สล็อต กีฬา  ฝาก - ถอน ระบบอัตโนมัติ 24 ชม" onClick={() => ((item.status === 3 || item.status === 0 || item.status === 1) || (checkPromotion === 1 && item.promotion === 1)) ? null : loadGame(item)} /> */}
                                                        
                                                        {
                                                            pageType !== "casino" && (
                                                                <div className={classes.heartContentPosition}>
                                                                    {
                                                                        renderHearth(item, index)
                                                                    }
                                                                </div>
                                                            )
                                                        }

                                                        {
                                                            pageType === "hit" || pageType === "casino" ?
                                                                null
                                                                :
                                                                <div className={classes.pageTypeJackpotPositionTop}>
                                                                    <div className={[bagdeStyles.ribbon, "center"].join(" ")} style={{ background: "linear-gradient(180deg, #00E0FF 0%, #0066FF 100%)" }}>
                                                                        แตก {currencyFormat(item.jackpot, 0)} ครั้ง
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}